import { Directive } from '@angular/core';
import { Validator, NG_VALIDATORS, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[isEmail]',
  providers: [{ provide: NG_VALIDATORS, useExisting: ValidEmailDirective, multi: true }]
})
export class ValidEmailDirective implements Validator {
  public constructor() { }

  public validate(control: AbstractControl): { [key: string]: any } {
    // let emailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
    //let emailRegEx = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    	
    let emailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    let valid = emailRegEx.test(control.value);
    if (control.value === null || control.value === undefined) {
      return { 'isEmail': true };
    }
    else {
      if (control.value.trim().length > 100) {
        return { 'isEmailMaxLength': true };
      }
      else {
        return control.value < 1 || valid ? null : { 'isEmail': true };
      }
    }

  }
}


// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/directives/common/valid-email.directive.ts